import React from 'react';
import { styled } from '@mui/material/styles';
import { PeekChip } from './PeekChip.js';
import { PeekDivider } from './PeekDivider.js';
import { PeekStack } from './PeekStack.js';
import { PeekTypography } from './PeekTypography.js';

const StepButton = styled("button")(({ theme }) => ({
    border: 0,
    background: "none",
    padding: 0,
    margin: 0,
    font: "inherit",
    color: "inherit",
    cursor: "pointer",
    borderRadius: theme.spacing(0.4),
    "&:focus-visible": {
        outline: `${theme.spacing(0.2)} solid ${theme.palette.secondary.main}`,
        outlineOffset: theme.spacing(0.2),
    },
}));
/** Numbered steps joined by dividers: the active one is highlighted, the others dimmed. */
const PeekStepIndicator = ({ steps, activeStep, onStepClick, sx }) => (React.createElement(PeekStack, { direction: "row", width: "100%", alignItems: "center", spacing: 2, sx: sx }, steps.map((step, index) => {
    const isActive = index === activeStep;
    const content = (React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.5 },
        React.createElement(PeekChip, { size: "small", label: step.error ? "!" : index + 1, disabled: !isActive && !step.error, color: step.error ? "error" : isActive ? "primary" : "info" }),
        React.createElement(PeekTypography, null, step.label)));
    return (React.createElement(React.Fragment, { key: index },
        onStepClick ? (React.createElement(StepButton, { type: "button", "aria-current": isActive ? "step" : undefined, "aria-label": `Step ${index + 1}: ${step.label}${step.error ? " (needs attention)" : ""}`, onClick: () => onStepClick(index) }, content)) : (content),
        index < steps.length - 1 && React.createElement(PeekDivider, { light: true, sx: { flex: 1, mx: 0.5 } })));
})));

export { PeekStepIndicator, PeekStepIndicator as default };
